import { ECOSYSTEM_CONDITIONS_FETCH } from "../actions/ecosystemConditionActions";

const ecosystemConditionsReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case ECOSYSTEM_CONDITIONS_FETCH:
      return action.payload;
    default:
      return state;
  }
};

export default ecosystemConditionsReducer;
